export const useNeedResizeIframe = () => {
  const handleResizeIframe = (height, isNewStructureId) => {
    const parentDocument = window.parent.document;
    const iframeElement = parentDocument.getElementById("newsContent");

    if (iframeElement && !isNewStructureId) {
      iframeElement.height = height + 100;
    }

    if (isNewStructureId && parentDocument) {
      // Quitar la visualización del scrollbar pero permitir el scroll
      const parentHtml = parentDocument.documentElement; // <html> del documento padre

      // Aplicar estilos en línea para ocultar visualmente el scrollbar
      parentHtml.style.overflow = "scroll"; // Permitir el scroll
      parentHtml.style.setProperty("--scrollbar-width", "0");
      parentHtml.style.setProperty("--scrollbar-thumb-bg", "transparent");
      parentHtml.style.setProperty("--scrollbar-track-bg", "transparent");

      const style = `
       ::-webkit-scrollbar {
         width: 0;
         height: 0;
       }
       ::-webkit-scrollbar-track {
         background: 0;
          width: 0;
         height: 0;
       }
       ::-webkit-scrollbar-thumb {
         background: transparent;
         border-radius: 0;
          width: 0;
         height: 0;
       }
       ::-webkit-scrollbar-thumb:hover {
         background: transparent;
          width: 0;
         height: 0;
       }

       /* For Firefox */
        html {
          scrollbar-width: none;
          scrollbar-color: transparent transparent;
        }

        /* For Internet Explorer and Edge */
        html {
          -ms-overflow-style: none;
        }
     `;

      // Crear un elemento <style> para aplicar los estilos
      const styleElement = parentDocument.createElement("style");
      styleElement.textContent = style;
      parentDocument.head.appendChild(styleElement);
    }
  };

  return {
    handleResizeIframe,
  };
};
